<template>
    <div class="carousel-section" data-aos="fade-up">
        <div class="container px-4 py-24 mx-auto show-on-scroll">
            <div class="mb-12 text-4xl leading-none text-center text-000 md:text-5xl title-text">
                Why WSC Waterkids?
            </div>
            <div class="w-full mx-auto mb-12 text-center text-4 md:w-8/12">
                <p>We have children of my own, so we understand them, we know they require our patience and care. It is our commitment to provide your child not only a fun and enjoyable lesson, also safe and fruitful training each time. Our coaches truly believe in providing attentive and safe environment for all students.</p>
            </div>
            <div class="grid grid-cols-1 sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-4">
                <div class="px-4 py-12 mx-4 mb-8 text-center border border-black rounded-lg lg:mx-2 xl:mx-4" data-aos="fade-up" :data-aos-delay="(i*2)+'00'">
                    <div class="mb-8 text-center">
                        <img src="/images/class-icon.png" class="inline-block">
                    </div>
                    <div class="text-xl leading-tight title-text mb-2">
                        Small Group Teaching
                    </div>
                    <ul class="list-disc text-left pl-6 ml-4">
                        <li>4 to 6 students each group</li>
                        <li>Positive environment (no aggression or argument)</li>
                    </ul>
                </div>
                <div class="px-4 py-12 mx-4 mb-8 text-center border border-black rounded-lg lg:mx-2 xl:mx-4" data-aos="fade-up" :data-aos-delay="(i*2)+'00'">
                    <div class="mb-8 text-center">
                        <img src="/images/teaching-icon.png" class="inline-block">
                    </div>
                    <div class="text-xl leading-tight title-text mb-2">
                        Holistic Proven Teaching
                    </div>
                    <ul class="list-disc text-left pl-6 ml-4">
                        <li>Easy to follow modules</li>
                        <li>Early childhood teaching concept</li>
                    </ul>
                </div>
                <div class="px-4 py-12 mx-4 mb-8 text-center border border-black rounded-lg lg:mx-2 xl:mx-4" data-aos="fade-up" :data-aos-delay="(i*2)+'00'">
                    <div class="mb-8 text-center">
                        <img src="/images/coach-icon.png" class="inline-block">
                    </div>
                    <div class="text-xl leading-tight title-text mb-2">
                        Certified Coaches
                    </div>
                    <ul class="list-disc text-left pl-6 ml-4">
                        <li>Singapore Swimming Association (SSA)</li>
                        <li>Singapore Ministry of Education (MOE)</li>
                        <li>Singapore Lifesaving Society</li>
                        <li>AUSTSWIM in Infant and Preschool Aquatics</li>
                        <li>American Red Cross in Water Safety Instructor</li>
                    </ul>
                </div>
                <div class="px-4 py-12 mx-4 mb-8 text-center border border-black rounded-lg lg:mx-2 xl:mx-4" data-aos="fade-up" :data-aos-delay="(i*2)+'00'">
                    <div class="mb-8 text-center">
                        <img src="/images/global-icon.png" class="inline-block">
                    </div>
                    <div class="text-xl leading-tight title-text mb-2">
                        Global Support
                    </div>
                    <ul class="list-disc text-left pl-6 ml-4">
                        <li>International Swimming Conferences</li>
                        <li>International Swim School Spectacular</li>
                    </ul>
                </div>
            </div>
            <!--<div class="block md:flex">
                <div class="w-full md:w-1/2 my-10 md:px-8">
                    <div class="mb-10 text-2xl leading-none text-center text-000 md:text-3xl title-text">
                        Trained Coaches
                    </div>
                    <p>Baby swimming classes and young toddler swimming lessons is conducted by experience and dedicated swimming coaches and instructors.</p>
                    <p>All coaches / instructors are trained in</p>
                    <ul class="list-disc text-left pl-5">
                        <li>Singapore Swimming Association (SSA)</li>
                        <li>Singapore Ministry of Education (MOE)</li>
                        <li>Singapore Lifesaving Society</li>
                        <li>AUSTSWIM in Infant and Preschool Aquatics</li>
                        <li>American Red Cross in Water Safety Instructor</li>
                    </ul>
                </div>
                <div class="w-full md:w-1/2 my-10 md:px-8">
                    <div class="mb-10 text-2xl leading-none text-center text-000 md:text-3xl title-text">
                        Holistic and High-Quality Teaching
                    </div>
                    <p>Our Team promote child, parents, and teacher relationship, creating a holistic teaching environment towards positive teaching methodology.</p>
                    <ul class="list-disc text-left pl-5">
                        <li>Lessons are simple and easy to follow.</li>
                        <li>Small groups (4 to 6 students)</li>
                        <li>Positive environment for all students. (No aggressive behaviour, argument,)</li>
                        <li>Early Childhood teaching concept.</li>
                    </ul>
                </div>
            </div>
            <div class="block md:flex">
                <div class="w-full md:w-1/2 my-10 md:px-8">
                    <div class="mb-10 text-2xl leading-none text-center text-000 md:text-3xl title-text">
                        Global Support
                    </div>
                    <p>
                        Our team are connected within the International Swimming Community. We attend world-class seminars and international Swimming Conferences bi-annually.
                    </p>
                    <img src="/images/global-support.jpg" class="inline-block fluid rounded">
                </div>
                <div class="w-full md:w-1/2 my-10 md:px-8">
                    <div class="mb-10 text-2xl leading-none text-center text-000 md:text-3xl title-text">
                        Giving The Best
                    </div>
                    <p>
                        A comprehensive study was done in 2013 by Griffith University that 7000 babies under 5 from Australia, New Zealand and the US showed that young children who participated in early-years swimming achieve a wide range of skills earlier than the normal population*
                    </p>
                    <p>
                        <a class="text-siteDarkBlue text-sm" href="https://news.griffith.edu.au/2012/11/15/swimming-kids-are-smarter/" target="_blank">https://news.griffith.edu.au/2012/11/15/swimming-kids-are-smarter</a>
                    </p>
                </div>
            </div>-->
            <div class="mt-10 mb-10 text-2xl leading-none text-center text-000 md:text-3xl title-text md:mt-16">
                Trusted and Certified
            </div>
            <div class="grid grid-cols-2 sm:grid-cols-2 md:grid-cols-5">
                <div class="px-4 mb-8 text-center border-black lg:px-8 xl:px-12" data-aos="fade-up" :data-aos-delay="(i*1)+'00'" v-for="(distributor, i) in distributors" :key="i">
                    <div class="mb-8 text-center">
                        <img :src="distributor.logo" :alt="distributor.name" :title="distributor.name" class="inline-block">
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data () {
            return {
                inclusions: [
                    {
                        thumbnail: '/images/class-icon.png',
                        name: 'Small Group Teaching',
                    },
                    {
                        thumbnail: '/images/teaching-icon.png',
                        name: 'Proven Teaching Methodology',
                    },
                    {
                        thumbnail: '/images/safety-icon.png',
                        name: 'Safety Priority',
                    },
                    {
                        thumbnail: '/images/specialised-icon.png',
                        name: 'Toddlers & Babies Specialised',
                    }
                ],
                distributors: [
                    {
                        logo: '/images/austswim.jpg',
                        name: 'Austswim'
                    },
                    {
                        logo: '/images/singapore-swimming.jpg',
                        name: 'Singapore Swimming Association'
                    },
                    {
                        logo: '/images/slss.jpg',
                        name: 'SLSS'
                    },
                    {
                        logo: '/images/nroc.jpg',
                        name: 'NROC'
                    },
                    {
                        logo: '/images/issa.jpg',
                        name: 'ISSA'
                    }
                ]
            }
        }
    }
</script>

<style>

</style>